function doRender(options) {
  if (!!window.olapic && typeof window.olapic.prepareWidget === 'function') {
    window.olapic.prepareWidget(options, {
      'renderNow': true, // required
      'force': true // optional - overwrites the widget index on load
    });
  }
}
(function ($) {
  Drupal.behaviors.sppOlapicV2 = {
    isMobile: false,
    attach: function (context) {
      var self = this;

      if (this.attached) {
        return;
      }
      this.attached = true;
      var $olapicWidget = $('#spp_olapic_widget', context);
      var $product = $('.js-product-full-v2, .js-product-full-v3', context);

      if ($olapicWidget.length < 1) {
        // if there is no widget on the page return
        return;
      }
      self.setDevice($olapicWidget);
      // skuSelect triggers before behaviors, use the product data skuBaseId for the page load render
      self.renderSelectedSku($product.attr('data-sku-base-id'), 'sku', $olapicWidget, $product);
      // only check by js-product-full- v2 & v3 as we need the main product of the SPP and not
      // the ones loaded in product briefs
      $(document).on('product.skuSelect', '.js-product-full-v2, .js-product-full-v3', function (e, skuBaseId) {
        skuBaseId = skuBaseId || $(this).data('skuBaseId');
        if ($olapicWidget.hasClass('olapic-widget-rendered')) {
          // if the olapic didn't rendered yet, we can't retrigger the render as it will duplicate the sliders
          self.renderSelectedSku(skuBaseId, 'sku', $olapicWidget, $product);
        }
      });
    },

    setDevice: function ($olapicWidget) {
      var self = this;
      var breakPoint = Unison.fetch.now();

      self.isMobile = breakPoint.name === 'small';
      Unison.on('change', function (currentBreakPoint) {
        self.isMobile = currentBreakPoint.name === 'small';
        if (breakPoint.name !== currentBreakPoint.name && breakPoint.name === 'small' || currentBreakPoint.name === 'small') {
          self.deviceChanged($olapicWidget);
        }
      });
    },

    deviceChanged: function ($olapicWidget) {
      var self = this;

      self.truncateCaption($olapicWidget);
      self.resetOlapicArrowsPosition($olapicWidget);
      self.positionOlapicArrows($olapicWidget);
    },

    renderSelectedSku: function (tags, renderedBy, $olapicWidget, $product) {
      if ($olapicWidget.hasClass('js-selectSku-loading')) {
        // the selectSku get's triggered multiple times from some parts of the SPP
        // make sure we only start the render once
        return;
      }
      var $olapicWrapper = $olapicWidget.closest('.js-spp-olapic--v2');
      var olapicInstance = $olapicWrapper.data('instance');
      var self = this;

      $olapicWidget.data('tags', tags)
        .data('renderedBy', renderedBy);
      $olapicWidget = self.resetWidgetClass($olapicWidget);
      $olapicWidget.addClass('js-selectSku-loading');
      self.listenToOlapic($olapicWidget, renderedBy, $product);
      doRender({
        'id': olapicInstance, // Widget Instance Name: SPP
        'wrapper': 'spp_olapic_widget',
        'tags': tags
      });
    },

    listenToOlapic: function ($olapicWidget, renderedBy, $product) {
      var self = this;
      // Options for the observer (which mutations to observe)
      var config = { attributes: true };
      var noItemsFlag = ['olapic_items_0', 'olapic_items_1', 'olapic_items_2', 'olapic_items_3'];
      var olapicWidgetClasses = [];
      var noUgcCheck = [];
      var prodID;
      // Callback function to execute when mutations are observed
      var callback = function (mutationsList, observer) {
        $.each(mutationsList, function (i, mutation) {
          if (!self.isWidgetReady($olapicWidget, mutation)) {
            return;
          }
          $olapicWidget.removeClass('js-selectSku-loading');
          olapicWidgetClasses = $olapicWidget.attr('class').split(' ');
          noUgcCheck = self.arrayIntersect(noItemsFlag, olapicWidgetClasses);
          if (noUgcCheck.length > 0 && renderedBy === 'sku') {
            // reload the widget based on product_id, do this only once, so
            // if there are no images on product either we just stop here
            $olapicWidget = self.resetWidgetClass($olapicWidget);
            // Providing fallback
            prodID = $product.data('productId') || '';
            self.renderSelectedSku(prodID.replace('PROD', ''), 'product', $olapicWidget);
            // we need to reset the class to allow the arrows to be position if fallbacks on product
            $olapicWidget.removeClass('arrows-positioned-processed');
            observer.disconnect();

            return false;
          }
          self.toggleOlapicPanel($olapicWidget, noUgcCheck);
          self.positionOlapicArrows($olapicWidget);
          self.truncateCaption($olapicWidget);
          observer.disconnect();

          // can break the loop once we pass on first mutation that made the widget reaady
          return false;
        });
      };
      // Create an observer instance linked to the callback function
      var observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe($olapicWidget[0], config);
    },

    resetOlapicArrowsPosition: function ($olapicWidget) {
      if ($olapicWidget.hasClass('arrows-positioned-processed')) {
        var $arrowLeft = $('.olapic-nav-prev', $olapicWidget);
        var $arrowRight = $('.olapic-nav-next', $olapicWidget);

        $arrowLeft.css({ 'left': '' });
        $arrowRight.css({ 'left': '' });
        $olapicWidget.removeClass('arrows-positioned-processed');
      }
    },

    positionOlapicArrows: function ($olapicWidget) {
      var self = this;
      var $olapicBody = $('.olapic-slider-body', $olapicWidget);
      var olapicBodyWidth = $olapicBody.width();

      if ($olapicBody && olapicBodyWidth < 1024) {
        $olapicBody.addClass('olapic-slider-body-medium');
      }
      if (!self.isMobile) {
        return;
      }
      $olapicWidget.once('arrows-positioned', function () {
        var $arrowLeft = $('.olapic-nav-prev', $olapicWidget);
        var $arrowRight = $('.olapic-nav-next', $olapicWidget);
        var extraSpace = parseInt($arrowLeft.outerWidth(true) / 2);
        var $olapicContainer = $('.olapic-carousel-list-container', $olapicWidget);
        var leftOffset = ($olapicContainer.outerWidth(true) - $olapicContainer.outerWidth(false)) / 2 - extraSpace;
        var olapicItemWidth = $('.olapic-item', $olapicWidget).parent().outerWidth(true);
        var rightLeftOffset = leftOffset + olapicItemWidth;

        // If values are negative then return
        if (leftOffset < 0 || rightLeftOffset < 0) {
          return;
        }
        $arrowLeft.css({ 'left': leftOffset + 'px' });
        $arrowRight.css({
          'right': '',
          'left': rightLeftOffset + 'px'
        });
      });
    },

    truncateCaption: function ($olapicWidget) {
      var self = this;

      if ($olapicWidget.attr('disable-caption-truncate')) {
        return;
      }
      // data-truncate-caption-at is set from Olapic for easier customisation per local
      var truncateAt = self.isMobile ? $olapicWidget.attr('data-truncate-mobile-caption-at') || 100 : $olapicWidget.attr('data-truncate-caption-at') || 180;
      var $captions = $olapicWidget.find('.olapic-moreinfo-caption');
      var $caption = $();
      var $captionInner = $();
      var captionText = '';
      var maxHeight = 60;
      var maxIterations = 10;

      $captions.each(function () {
        var i = 0;

        $caption = $(this);
        maxHeight = $caption.height();
        $captionInner = $caption.find('.js-olapic-moreinfo-caption--inner');
        if (typeof $captionInner.data('originalCaption') === 'undefined') {
          captionText = $captionInner.html();
          // we save the caption to have unison change trigger show the correct value
          $captionInner.data('originalCaption', captionText);
        } else {
          captionText = $captionInner.data('originalCaption');
        }
        if (captionText.length > truncateAt) {
          captionText = captionText.substr(0, truncateAt) + '...';
        }

        $captionInner.html(captionText);
        while ($captionInner.height() > maxHeight && i < maxIterations) {
          // only do maxIterations ( 10 ) iterations to prevent infinit loop
          i++;
          $captionInner.text(function (index, text) {
            return text.replace(/\W*\s(\S)*$/, '...');
          });
        }
        $caption.html($captionInner);
      });
    },

    toggleOlapicPanel: function ($olapicWidget, noUgcCheck) {
      if (noUgcCheck.length > 0) {
        $olapicWidget.closest('.spp-product-layout__content-item').addClass('hidden');
      } else {
        $olapicWidget.closest('.spp-product-layout__content-item').removeClass('hidden');
      }
    },

    resetWidgetClass: function ($olapicWidget) {
      return $olapicWidget.removeClass(function (index, classes) {
        var
          classesArray = classes.split(' '),
          removeClass = _.filter(classesArray, function (className) {
            return className.indexOf('olapic_items_') === 0;
          }).toString();

        return removeClass;
      });
    },

    isWidgetReady: function ($olapicWidget, mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName !== 'class') {
        // return if other attribute was changed
        return false;
      }
      if ($olapicWidget.attr('class').indexOf('olapic_items_') === -1) {
        // return if the items count is not set yet
        return false;
      }

      return true;
    },

    arrayIntersect: function (array1, array2) {
      var arr = [];

      if (typeof array1 === 'object' && typeof array2 === 'object') {
        arr = array1.filter(function (a) {
          return array2.filter(function (b) {
            return a === b;
          }).length;
        });
      }

      return arr;
    },

    attached: false
  };
})(jQuery);
